module.exports = __webpack_public_path__ + "media/images/icon-lifecycle-7f0a722b422673118ccdbf6086e3389a.svg";